// extracted by mini-css-extract-plugin
export const desktopMenu = "bt_c8";
export const phoneMenu = "bt_c9";